import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { ThemeProvider } from './components/ThemeProvider.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { ErrorProvider } from './contexts/ErrorContext.tsx'
import './index.css'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorProvider>
      <ErrorBoundary
        level="global"
        enableLogging={true}
        maxRetries={3}
        onError={(error, errorInfo, errorDetails) => {
          // Global error handler - could send to analytics service
          console.error('Global error caught:', { error, errorInfo, errorDetails });
        }}
      >
        <ThemeProvider defaultTheme="light" storageKey="accountantai-theme">
          <App />
        </ThemeProvider>
      </ErrorBoundary>
    </ErrorProvider>
  </React.StrictMode>,
)
